import { latestSearchesClient } from '@y2/api-clients/latest-searches';

export const latestSearches = latestSearchesClient();
